import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js";

export default class extends Controller {
  connect() {
  }
  
  copy(event) {
    event.preventDefault()
    
    const button = event.currentTarget
    const directUrl = button.dataset.directUrl
    
    
    // Create a temporary textarea element to copy from
    const textarea = document.createElement('textarea')
    textarea.value = directUrl
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'absolute'
    textarea.style.left = '-9999px'
    document.body.appendChild(textarea)
    
    // Select and copy the text
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
    
    // Show success tooltip
    this.showTooltip(button, "Direct link copied!")
    
    // Visual feedback
    const originalClass = button.className
    button.className = button.className.replace("btn-primary", "btn-success")
    
    // Reset button after delay
    setTimeout(() => {
      button.className = originalClass
    }, 2000)
  }
  
  showTooltip(element, message) {
    tippy(element, {
      content: message,
      showOnCreate: true,
      onHidden: (instance) => {
        instance.destroy()
      }
    })
  }
}
